import { OutIcon } from 'Asset/icon';

export const dropdownItems = [{ icon: <OutIcon />, text: 'Logout' }];
